<div mat-dialog-actions class="flex-row justify-end mb-10">
  <i class="fas fa-times" mat-dialog-close></i>
</div>
<mat-dialog-content>
  <app-p2p-static-page [staticPageModel]="data" [isPreview]="true"></app-p2p-static-page>
</mat-dialog-content>